import React, { Component } from 'react';
import { Modal, Radio, message } from 'antd';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';

const RadioGroup = Radio.Group;

class ExportModal extends Component {
    state = {
        visible: false,
        searchParams: {},
        pagination: {},
    }

    show = (searchParams, pagination) => {
        this.setState({
            visible: true,
            searchParams,
            pagination,
        });
    }

    handleOk = () => {
        const { searchParams, pagination } = this.state;
        const { type } = searchParams;
        const text = type === 'marketRegiste' ? '重要里程碑和上市登记（汇总数据）' : '重要里程碑（项目层面）';
        ExportUtil.export(searchParams, pagination, API_URL.nationalverification.exportNationVerifyList);
        message.success(`${text}开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`)
        this.handleCancel();
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    onChange = (e) => {
        const { searchParams } = this.state;
        searchParams.type = e.target.value;
        this.setState({ searchParams });
    }

    render() {
        const { visible, searchParams } = this.state;
        const { type } = searchParams;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="350px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <div className="item" >
                        <label className="ui-label">请选择要导出内容 ：</label>
                    </div>
                    <div className="item" style={{margin: '0 50px'}}>
                        <RadioGroup onChange={this.onChange} value={type}>
                            <div style={{ marginTop: 15 }}><Radio value="importantMilestone">重要里程碑（项目层面）</Radio></div>
                            <div style={{ marginTop: 15 }}><Radio value="marketRegiste">重要里程碑和上市登记（汇总数据）</Radio></div>
                        </RadioGroup>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default ExportModal;



// WEBPACK FOOTER //
// ./src/components/qualityManagement/ImportantMilestone/components/ExportModal.js